import { render, staticRenderFns } from "./chart3.vue?vue&type=template&id=2987cf26&scoped=true&"
import script from "./chart3.vue?vue&type=script&lang=js&"
export * from "./chart3.vue?vue&type=script&lang=js&"
import style0 from "./chart3.vue?vue&type=style&index=0&id=2987cf26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987cf26",
  null
  
)

export default component.exports